export const mapFileURLsToObjects = (fileURLs) => {
    return fileURLs.map((url) => {
        const parts = url.split('/')
        const fullName = parts[parts.length - 1] // e.g., "download_1754546356.jpg"

        const [fileName, fileType] = (() => {
            const dotIndex = fullName.lastIndexOf('.')
            if (dotIndex === -1) return [fullName, ''] // No extension
            return [fullName.slice(0, dotIndex), fullName.slice(dotIndex + 1)]
        })()

        return {
            fileName,
            fileLink: url,
            fileType,
            uploadDate: new Date().getTime(),
        }
    })
}
